<div class="flex flex-col gap-5">
  <div class="flex flex-col md:flex-row md:items-center gap-y-4">
    <div class="flex flex-col flex-1">
      <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
        {{ 'cockpit.supplierContracts.details.price.title' | transloco }}
      </h3>
      <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
        {{ 'cockpit.supplierContracts.details.price.description' | transloco }}
      </p>
    </div>
    <div class="flex-none flex gap-4">
      <ui-switch-bar [formField]="filterForm.view" class="flex-1">
        <ui-switch-bar-option value="PRICE">
          <div class="flex gap-1.5 items-center px-1">
            <ng-icon name="heroCurrencyEuro" size="20" class="!block" />
            <span class="inline md:hidden">
              {{ 'cockpit.supplierContracts.details.price.showPrices' | transloco }}
            </span>
            <span class="hidden md:inline">
              {{ 'cockpit.supplierContracts.details.price.showPricesLong' | transloco }}
            </span>
          </div>
        </ui-switch-bar-option>
        <ui-switch-bar-option value="FORECAST">
          <div class="flex gap-1.5 items-center px-1">
            <ng-icon name="heroBanknotes" size="20" class="!block" />
            <span class="inline md:hidden">
              {{ 'cockpit.supplierContracts.details.price.showCosts' | transloco }}
            </span>
            <span class="hidden md:inline">
              {{ 'cockpit.supplierContracts.details.price.showCostsLong' | transloco }}
            </span>
          </div>
        </ui-switch-bar-option>
      </ui-switch-bar>
      <div class="flex md:hidden gap-1 flex-none">
        <ui-button [iconOnly]="true" mode="outlined" (click)="filterDialog.showModal()">
          <ng-icon name="heroFunnel" size="20" class="!block" />
        </ui-button>
        <ui-button mode="outlined" (click)="totalCostDialog.showModal()">
          <ng-icon name="heroBarsArrowUp" size="20" class="!block" slot="start" />
          {{ 'cockpit.supplierContracts.details.price.overviewButton' | transloco }}
        </ui-button>
      </div>
    </div>
  </div>
  <form class="grid grid-cols-2 gap-4">
    <ui-input-label class="hidden md:block">
      <div class="flex items-center gap-1">
        <span> {{ 'cockpit.supplierContracts.details.price.filter.yearLabel' | transloco }} </span>

        <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
          <h3 slot="title" class="font-semibold">
            {{ 'help.supplierContractYearFilter.title' | transloco }}
          </h3>
          <p>
            {{ 'help.supplierContractYearFilter.description' | transloco }}
          </p>
        </ui-help-button>
      </div>
      @if (!years().length) {
        <div>
          <ui-skeleton class="block w-20 h-6 rounded-md mb-2" />
          <ui-skeleton class="block w-full h-10 rounded-md" />
        </div>
      } @else {
        <ui-select [formField]="filterForm.year">
          @for (year of years(); track year) {
            <option [value]="year" [selected]="filterForm.year().value() === year">
              {{ year }}
            </option>
          }
        </ui-select>
      }
    </ui-input-label>
    @if (energyInterfacesLoading()) {
      <div class="hidden md:block w-full">
        <ui-skeleton class="block w-20 h-6 rounded-md mb-2" />
        <ui-skeleton class="block w-full h-10 rounded-md" />
      </div>
    } @else {
      <ui-input-label class="hidden md:block">
        <div class="flex items-center gap-1">
          <span>
            {{ 'cockpit.supplierContracts.details.price.filter.connectionLabel' | transloco }}
          </span>

          <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
            <h3 slot="title" class="font-semibold">
              {{ 'help.supplierContractConnectionFilter.title' | transloco }}
            </h3>
            <p>
              {{ 'help.supplierContractConnectionFilter.description' | transloco }}
            </p>
          </ui-help-button>
        </div>
        <ui-select [formField]="filterForm.energyInterfaceID">
          <option value="ALL">
            {{ 'cockpit.supplierContracts.details.price.filter.allOption' | transloco }}
          </option>
          @for (ei of energyInterfaces(); track ei.energyInterfaceID) {
            <option
              [value]="ei.energyInterfaceID"
              [selected]="filterForm.energyInterfaceID().value() === ei.energyInterfaceID"
            >
              {{ ei.energyInterfaceID | energyInterfaceLabel }}
            </option>
          }
        </ui-select>
      </ui-input-label>
    }

    <ui-simple-dialog #filterDialog>
      <ui-simple-dialog-layout class="w-full" (clickCancel)="filterDialog.close()">
        <ng-container slot="title">
          {{ 'cockpit.supplierContracts.details.price.filter.title' | transloco }}
        </ng-container>
        <div class="flex flex-col gap-6">
          <ui-input-label>
            <div class="flex items-center gap-1">
              <span>
                {{ 'cockpit.supplierContracts.details.price.filter.yearLabel' | transloco }}
              </span>

              <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
                <h3 slot="title" class="font-semibold">
                  {{ 'help.supplierContractYearFilter.title' | transloco }}
                </h3>
                <p>
                  {{ 'help.supplierContractYearFilter.description' | transloco }}
                </p>
              </ui-help-button>
            </div>
            <ui-select [formField]="filterForm.year">
              @for (year of years(); track year) {
                <option [value]="year" [selected]="filterForm.year().value() === year">
                  {{ year }}
                </option>
              }
            </ui-select>
          </ui-input-label>
          @if (energyInterfacesLoading()) {
            <div class="w-full">
              <ui-skeleton class="block w-20 h-6 rounded-md mb-2" />
              <ui-skeleton class="block w-full h-10 rounded-md" />
            </div>
          } @else {
            <ui-input-label>
              <div class="flex items-center gap-1">
                <span>
                  {{ 'cockpit.supplierContracts.details.price.filter.connectionLabel' | transloco }}
                </span>

                <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
                  <h3 slot="title" class="font-semibold">
                    {{ 'help.supplierContractConnectionFilter.title' | transloco }}
                  </h3>
                  <p>
                    {{ 'help.supplierContractConnectionFilter.description' | transloco }}
                  </p>
                </ui-help-button>
              </div>
              <ui-select [formField]="filterForm.energyInterfaceID">
                <option value="ALL">
                  {{ 'cockpit.supplierContracts.details.price.filter.allOption' | transloco }}
                </option>
                @for (ei of energyInterfaces(); track ei.energyInterfaceID) {
                  <option
                    [value]="ei.energyInterfaceID"
                    [selected]="filterForm.energyInterfaceID().value() === ei.energyInterfaceID"
                  >
                    {{ ei.energyInterfaceID | energyInterfaceLabel }}
                  </option>
                }
              </ui-select>
            </ui-input-label>
          }
        </div>
      </ui-simple-dialog-layout>
    </ui-simple-dialog>
  </form>
  @if (pricingStatus() === 'IN_SYNC') {
    @if (isLoading()) {
      <div class="flex gap-6">
        <section class="flex-1 overflow-auto">
          <app-supplier-contract-price-table-skeleton />
        </section>
        <section class="flex-none hidden md:block">
          <div
            class="w-full bg-surface-magic dark:bg-surface-magic-darkmode rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
          >
            <div class="px-6 pt-5">
              <ui-skeleton class="block h-4 w-30 rounded-full" />
            </div>
            <div class="p-6">
              <app-supplier-contract-price-total-card-skeleton class="block w-72" />
            </div>
          </div>
        </section>
      </div>
    } @else if (error()) {
      <app-error-component [enableRetry]="true" (clickRetry)="onClickRetry()">
        <span class="flex flex-col items-center">
          @if (errorStatus() === 400) {
            <span>{{ 'cockpit.supplierContracts.errors.pricesCalculating' | transloco }}</span>
            <span>{{ 'cockpit.supplierContracts.errors.tryAgainLater' | transloco }}</span>
          } @else if (errorStatus() === 404) {
            {{ 'cockpit.supplierContracts.errors.pricesNotFound' | transloco }}
          }
        </span>
      </app-error-component>
    } @else {
      <div class="flex gap-6">
        <section
          [attr.aria-label]="'cockpit.supplierContracts.details.price.tableSection' | transloco"
          class="flex-1 overflow-auto"
        >
          <app-supplier-contract-price-table
            [supplierContractID]="supplierContractID()"
            [supplierContract]="supplierContract()"
            [organizationID]="organizationID()"
            [view]="filterForm.view().value()"
            [energyInterfaceID]="filterForm.energyInterfaceID().value()"
            [year]="filterForm.year().value()"
            [cost]="cost()?.data"
            [price]="prices()?.data"
          />
        </section>
        <section
          [attr.aria-label]="'cockpit.supplierContracts.details.price.sidebarSection' | transloco"
          class="flex-none hidden md:block"
        >
          <div
            class="w-full bg-surface-magic dark:bg-surface-magic-darkmode rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
          >
            <div class="px-6 pt-5">
              <h3 class="text-base font-semibold leading-6 line-clamp-1">
                @if (filterForm.view().value() === 'PRICE') {
                  {{ 'cockpit.supplierContracts.details.price.sidebar.title' | transloco }}
                } @else {
                  {{
                    'cockpit.supplierContracts.details.price.sidebar.costForecastTitle' | transloco
                  }}
                }
              </h3>
            </div>
            <div class="p-6">
              <app-supplier-contract-price-total-card
                class="block w-72"
                [supplierContract]="supplierContract()"
                [selectedYear]="+filterForm.year().value()"
                [selectedEnergyInterfaceID]="
                  filterForm.energyInterfaceID().value() === 'ALL'
                    ? undefined
                    : filterForm.energyInterfaceID().value()
                "
                [view]="filterForm.view().value()"
                [cost]="cost()?.data"
                [price]="prices()?.data"
              />
            </div>
          </div>
        </section>
      </div>
    }
  } @else {
    <app-error-component class="block" [enableRetry]="true" (clickRetry)="onClickReload()">
      {{ 'cockpit.supplierContracts.details.price.updating' | transloco }}
    </app-error-component>
  }
</div>

<ui-simple-dialog #totalCostDialog>
  <ui-simple-dialog-layout class="w-full" (clickCancel)="totalCostDialog.close()">
    <ng-container slot="title">
      @if (filterForm.view().value() === 'PRICE') {
        {{ 'cockpit.supplierContracts.details.price.sidebar.title' | transloco }}
      } @else {
        {{ 'cockpit.supplierContracts.details.price.sidebar.costForecastTitle' | transloco }}
      }
    </ng-container>
    @if (isLoading()) {
      <app-supplier-contract-price-total-card-skeleton class="block w-full" />
    } @else if (error()) {
      <app-error-component [enableRetry]="true" (clickRetry)="onClickRetry()">
        <span class="flex flex-col items-center">
          @if (errorStatus() === 400) {
            <span>{{ 'cockpit.supplierContracts.errors.pricesCalculating' | transloco }}</span>
            <span>{{ 'cockpit.supplierContracts.errors.tryAgainLater' | transloco }}</span>
          } @else if (errorStatus() === 404) {
            {{ 'cockpit.supplierContracts.errors.pricesNotFound' | transloco }}
          }
        </span>
      </app-error-component>
    } @else {
      <app-supplier-contract-price-total-card
        class="block w-full"
        [supplierContract]="supplierContract()"
        [selectedYear]="+filterForm.year().value()"
        [selectedEnergyInterfaceID]="
          filterForm.energyInterfaceID().value() === 'ALL'
            ? undefined
            : filterForm.energyInterfaceID().value()
        "
        [view]="filterForm.view().value()"
        [cost]="cost()?.data"
        [price]="prices()?.data"
      />
    }
  </ui-simple-dialog-layout>
</ui-simple-dialog>
